function init() {

	// location accordion
	// Toggle content on click
	jQuery('.m-locations-block__location-name').on('click', function() {
		const $this = jQuery(this);
		const $content = $this.next('.m-locations-block__location-chunk');
		
		// Get the current state of the accordion (expanded or collapsed)
		const isExpanded = $this.attr('aria-expanded') === 'true';
		
		// Toggle the expanded state (aria-expanded)
		$this.attr('aria-expanded', !isExpanded);
		
		// Slide the content open or closed
		$content.stop().slideToggle(260, function() {
		// Toggle the "hidden" attribute based on visibility
		$content.attr('hidden', !isExpanded);
		});
	
		// Toggle the plus/minus icon text
		const $plusIcon = $this.find('.circle-plus');
		$plusIcon.text(isExpanded ? '+' : '-');
	});
	
	// Keyboard interaction (Enter or Space key)
	jQuery('.m-locations-block__location-name').on('keydown', function(event) {
		const $this = jQuery(this);
		
		// Trigger toggle on Enter or Space key
		if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
		event.preventDefault();  // Prevent scrolling on spacebar press
		$this.trigger('click');  // Trigger the click event programmatically
		}
	});
	
	// Allow users to tab through accordion items
	jQuery('.m-locations-block__location-name').on('focus', function() {
		jQuery(this).addClass('focused');
	}).on('blur', function() {
		jQuery(this).removeClass('focused');
	});
	
}

export {init as default};
